import { render, staticRenderFns } from "./novedades.vue?vue&type=template&id=06db08d7&scoped=true"
import script from "./novedades.vue?vue&type=script&lang=js"
export * from "./novedades.vue?vue&type=script&lang=js"
import style0 from "./novedades.vue?vue&type=style&index=0&id=06db08d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db08d7",
  null
  
)

export default component.exports